import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";

function AddSchool() {
  const navigate = useNavigate();

  const token = sessionStorage.getItem("intermediateAdminToken");
  const [loading, setLoading] = useState(true);

  const [previewMode, setPreviewMode] = useState(false);
  const isDisabled = previewMode;

  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);

  const [schoolInfo, setSchoolInfo] = useState({
    schooL_CODE: "",
    udisE_CODE: "",
    schooL_NAME: "",
    sC_ADDRESS: "",
    piN_CODE: "",
    area: "",
    posT_OFFICE: "",
    nearesT_RAILWAY_STATION: "",
    heaD_NAME: "",
    heaD_MOBILE_NO: "",
    emaiL_ADDRESS: "",
    asstistencE_TEACHER_CONTACT: "",
    challaN_LIMIT_CL_11: "",
    challaN_LIMIT_CL_12: "",
    challaN_LIMIT_CL_11_special_exam: "",
    challaN_LIMIT_CL_12_special_exam: "",
    quotA_ARTS_REG: "",
    quotA_ARTS_PRIV: "",
    quotA_COMMERCE_REG: "",
    quotA_COMMERCE_PRIV: "",
    quotA_SCIENCE_REG: "",
    quotA_SCIENCE_PRIV: "",
    permissioN_ARTS: "",
    permissioN_COMMERCE: "",
    permissioN_SCIENCE: "",
    APPROVED_ARTS: "",
    APPROVED_COMM: "",
    APPROVED_SCI: "",
  });

  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [typeofschool, setTypeofschool] = useState("");

  const [class11limit, setClass11limit] = useState("");
  const [class12limit, setClass12limit] = useState("");
  const [class11limitspecialexam, setClass11limitspecialexam] = useState("");
  const [class12limitspecialexam, setClass12limitspecialexam] = useState("");
  const [typeOfSchoolOptions, setTypeOfSchoolOptions] = useState([]);

  const [errors, setErrors] = useState({});

  const toOptions = (list, valueKey, labelKey) =>
    list.map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    }));

  function capitalizeFirst(str) {
    str = (str || "").toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const fetchPageLoadSecondaryDataSchool = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/PageLoadForInsertSchoolIntermediate`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        const groupData = data.data;
        setStateList(groupData.stateList);
        setDistrictList(groupData.districtList);
        setBlockList(groupData.blockList);
        setSubDivisionList(groupData.divisionlist);
        setSchoolInfo([]);
        setTypeOfSchoolOptions(
          groupData.schoolType.map((t) => ({
            value: t.typE_OF_SCHOOL,
            label: t.typE_OF_SCHOOL,
          }))
        );
      } else {
        Swal.fire("Error", "Unable to fetch page load data", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/intermediate-admin");
    } else {
      fetchPageLoadSecondaryDataSchool();
    }
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);

  const filteredDistricts = selectedState
    ? districtList.filter((d) => d.statE_CODE === selectedState.value)
    : [];
  const filteredBlocks = selectedDistrict
    ? blockList.filter((b) => b.disT_CODE === selectedDistrict.value)
    : [];
  const filteredSubDivisions = selectedDistrict
    ? subDivisionList.filter((s) => s.district === selectedDistrict.value)
    : [];

  const handleSelectChange = (level, value) => {
    switch (level) {
      case "state":
        setSelectedState(value);
        setSelectedDistrict("");
        setSelectedBlock("");
        setSelectedSubDivision("");
        break;
      case "district":
        setSelectedDistrict(value);
        setSelectedBlock("");
        setSelectedSubDivision("");
        break;
      case "block":
        setSelectedBlock(value);
        break;
      case "subdivision":
        setSelectedSubDivision(value);
        break;
      default:
        break;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = String(value || ""); /* .trim() */

    // Disallow '|' anywhere
    if (/[|]/.test(newValue)) return;

    // Disallow multiple consecutive spaces
    if (/\s{2,}/.test(newValue)) return;

    // Convert text fields to uppercase
    if (
      name === "typE_OF_SCHOOL" ||
      name === "heaD_NAME" ||
      name === "schooL_NAME"
    ) {
      if (/[^a-zA-Z\s]/.test(newValue)) return; // letters & spaces only
      newValue = newValue.toUpperCase();
    }

    // Numeric fields
    if (
      name === "schooL_CODE" ||
      name === "udisE_CODE" ||
      name === "telephonE_NO" ||
      name === "piN_CODE" ||
      name === "heaD_MOBILE_NO" ||
      name === "asstistencE_TEACHER_CONTACT" ||
      name === "challaN_LIMIT_CL_11" ||
      name === "challaN_LIMIT_CL_12" ||
      name === "challaN_LIMIT_CL_11_special_exam" ||
      name === "challaN_LIMIT_CL_12_special_exam" ||
      name === "quotA_ARTS_REG" ||
      name === "quotA_ARTS_PRIV" ||
      name === "quotA_COMMERCE_REG" ||
      name === "quotA_COMMERCE_PRIV" ||
      name === "quotA_SCIENCE_REG"
    ) {
      if (/[^0-9]/.test(newValue)) return;

      // Limit length for mobile/telephone fields
      if (
        (name === "telephonE_NO" ||
          name === "heaD_MOBILE_NO" ||
          name === "asstistencE_TEACHER_CONTACT") &&
        newValue.length > 10
      ) {
        return;
      }
      if (name === "piN_CODE" && newValue.length > 6) {
        return;
      }
    }
    if (name === "emaiL_ADDRESS") {
      newValue = newValue.toLowerCase();
    }

    // Fields allowing letters, digits, and spaces only
    if (name === "posT_OFFICE" || name === "nearesT_RAILWAY_STATION") {
      if (/[^a-zA-Z0-9\s]/.test(newValue)) return;
      newValue = newValue.toUpperCase(); // optional: convert to uppercase
    }
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    // Update state
    setSchoolInfo({ ...schoolInfo, [name]: newValue });
  };

  const handlePreview = () => {
    const newErrors = {};
    const trimmed = (val) => String(val || "").trim();

    setLoading(true);

    setTimeout(() => {
      // --- School basic details ---
      if (!trimmed(schoolInfo.schooL_CODE)) {
        newErrors.schooL_CODE = "School code is required.";
      } else if (schoolInfo.schooL_CODE.length !== 5) {
        newErrors.schooL_CODE = "School code must be exactly 5 characters.";
      }

      if (!trimmed(schoolInfo.udisE_CODE)) {
        newErrors.udisE_CODE = "UDISE code is required.";
      } else if (schoolInfo.udisE_CODE.length > 15) {
        newErrors.udisE_CODE = "UDISE code cannot exceed 15 characters.";
      }

      if (!trimmed(schoolInfo.schooL_NAME)) {
        newErrors.schooL_NAME = "School name is required.";
      }

      if (!trimmed(schoolInfo.sC_ADDRESS)) {
        newErrors.sC_ADDRESS = "School address is required.";
      }

      if (!selectedState) {
        newErrors.state = "State is required.";
      }
      if (!selectedDistrict) {
        newErrors.districtcode = "District is required.";
      }
      if (!selectedBlock) {
        newErrors.blocK_NAME = "Block is required.";
      }

      // --- Contact details ---
      if (!trimmed(schoolInfo.heaD_MOBILE_NO)) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no is required.";
      } else if (schoolInfo.heaD_MOBILE_NO.length !== 10) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no must be 10 digits.";
      }

      if (
        schoolInfo.asstistencE_TEACHER_CONTACT &&
        schoolInfo.asstistencE_TEACHER_CONTACT.length !== 10
      ) {
        newErrors.asstistencE_TEACHER_CONTACT =
          "Assistant Teacher mobile no must be 10 digits.";
      }

      if (!trimmed(schoolInfo.emaiL_ADDRESS)) {
        newErrors.emaiL_ADDRESS = "Principal email is required.";
      }

      // --- Challan limits ---
      if (!trimmed(schoolInfo.challaN_LIMIT_CL_11)) {
        newErrors.challaN_LIMIT_CL_11 =
          "Allowed Number of Challan Generation for class 11 is required.";
      }
      if (!trimmed(schoolInfo.challaN_LIMIT_CL_12)) {
        newErrors.challaN_LIMIT_CL_12 =
          "Allowed Number of Challan Generation for class 12 is required.";
      }
      if (!trimmed(schoolInfo.challaN_LIMIT_CL_11_special_exam)) {
        newErrors.challaN_LIMIT_CL_11_special_exam =
          "Allowed Number of Challan Generation for class 11 special exam is required.";
      }
      if (!trimmed(schoolInfo.challaN_LIMIT_CL_12_special_exam)) {
        newErrors.challaN_LIMIT_CL_12_special_exam =
          "Allowed Number of Challan Generation for class 12 special exam is required.";
      }


      // --- Quotas ---
      if (!trimmed(schoolInfo.quotA_ARTS_REG)) {
        newErrors.quotA_ARTS_REG = "Arts regular quota is required.";
      }
      if (!trimmed(schoolInfo.quotA_ARTS_PRIV)) {
        newErrors.quotA_ARTS_PRIV = "Arts private quota is required.";
      }
      if (!trimmed(schoolInfo.quotA_COMMERCE_REG)) {
        newErrors.quotA_COMMERCE_REG = "Commerce regular quota is required.";
      }
      if (!trimmed(schoolInfo.quotA_COMMERCE_PRIV)) {
        newErrors.quotA_COMMERCE_PRIV = "Commerce private quota is required.";
      }
      if (!trimmed(schoolInfo.quotA_SCIENCE_REG)) {
        newErrors.quotA_SCIENCE_REG = "Science regular quota is required.";
      }

      // --- Permissions ---
      if (!trimmed(schoolInfo.permissioN_ARTS)) {
        newErrors.permissioN_ARTS = "Arts is required.";
      }
      if (!trimmed(schoolInfo.permissioN_COMMERCE)) {
        newErrors.permissioN_COMMERCE = "Commerce is required.";
      }
      if (!trimmed(schoolInfo.permissioN_SCIENCE)) {
        newErrors.permissioN_SCIENCE = "Science is required.";
      }
      if (!trimmed(schoolInfo.APPROVED_ARTS)) {
        newErrors.APPROVED_ARTS = "Arts approval status is required.";
      }
      if (!trimmed(schoolInfo.APPROVED_COMM)) {
        newErrors.APPROVED_COMM = "Commerce approval status is required.";
      }
      if (!trimmed(schoolInfo.APPROVED_SCI)) {
        newErrors.APPROVED_SCI = "Science approval status is required.";
      }
      // --- Finalize ---
      setErrors(newErrors);
      setLoading(false);

      if (Object.keys(newErrors).length === 0) {
        setPreviewMode(true);
      }
    }, 500);
  };

  const handleEdit = () => {
    setLoading(true);
    setTimeout(() => {
      setPreviewMode(false);
      setLoading(false);
    }, 500);
  };

  const handleSubmit = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to save the changes?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save it",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      setLoading(true);
      const payload = {
        schooL_CODE: schoolInfo.schooL_CODE || "",
        udisE_CODE: schoolInfo.udisE_CODE || "",
        schooL_NAME: schoolInfo.schooL_NAME || "",
        suB_DIVISION: selectedSubDivision?.value || "",
        sC_ADDRESS: schoolInfo.sC_ADDRESS || "",
        typE_OF_SCHOOL: schoolInfo.typE_OF_SCHOOL || "",
        state: selectedState?.value || "",
        district: selectedDistrict?.value || "",
        blocK_NAME: selectedBlock?.value || "",
        piN_CODE: schoolInfo.piN_CODE || "",
        area: schoolInfo.area || "",
        posT_OFFICE: schoolInfo.posT_OFFICE || "",
        nearesT_RAILWAY_STATION: schoolInfo.nearesT_RAILWAY_STATION || "",
        heaD_MOBILE_NO: schoolInfo.heaD_MOBILE_NO || "",
        emaiL_ADDRESS: schoolInfo.emaiL_ADDRESS || "",
        asstistencE_TEACHER_CONTACT:
          schoolInfo.asstistencE_TEACHER_CONTACT || "",
        heaD_NAME: schoolInfo.heaD_NAME || "",
        challaN_LIMIT_CL_11: String(schoolInfo.challaN_LIMIT_CL_11) || "",
        challaN_LIMIT_CL_12: String(schoolInfo.challaN_LIMIT_CL_12) || "",
        challaN_LIMIT_S_EXAM_CL_11: String(schoolInfo.challaN_LIMIT_CL_11_special_exam) || "",
        challaN_LIMIT_S_EXAM_CL_12: String(schoolInfo.challaN_LIMIT_CL_12_special_exam) || "",
        quotA_ARTS_REG: schoolInfo.quotA_ARTS_REG || "",
        quotA_ARTS_PRIV: schoolInfo.quotA_ARTS_PRIV || "",
        quotA_COMMERCE_REG: schoolInfo.quotA_COMMERCE_REG || "",
        quotA_COMMERCE_PRIV: schoolInfo.quotA_COMMERCE_PRIV || "",
        quotA_SCIENCE_REG: schoolInfo.quotA_SCIENCE_REG || "",
        quotA_SCIENCE_PRIV: schoolInfo.quotA_SCIENCE_PRIV || "",
        permissioN_ARTS: schoolInfo.permissioN_ARTS || "",
        permissioN_COMMERCE: schoolInfo.permissioN_COMMERCE || "",
        permissioN_SCIENCE: schoolInfo.permissioN_SCIENCE || "",
        APPROVED_ARTS: schoolInfo.APPROVED_ARTS || "",
        APPROVED_COMM: schoolInfo.APPROVED_COMM || "",
        APPROVED_SCI: schoolInfo.APPROVED_SCI || "",
        CREATED_BY: sessionStorage.getItem("schoolCode"),
      };

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/InsertSchoolDataIntermediate`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();

        if (response.ok && result.status === 200) {
          Swal.fire(
            "Success",
            "School data updated successfully",
            "success"
          ).then(() => {
            resetForm();
          });
        } else {
          Swal.fire(
            "warning",
            result.message || "Failed to update school data",
            "warning"
          );
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Something went wrong during submission", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const resetForm = () => {
    setSchoolInfo({
      schooL_CODE: "",
      udisE_CODE: "",
      schooL_NAME: "",
      sC_ADDRESS: "",
      piN_CODE: "",
      area: "",
      posT_OFFICE: "",
      nearesT_RAILWAY_STATION: "",
      heaD_NAME: "",
      heaD_MOBILE_NO: "",
      emaiL_ADDRESS: "",
      asstistencE_TEACHER_CONTACT: "",
      challaN_LIMIT_CL_11: "",
      challaN_LIMIT_CL_12: "",
      challaN_LIMIT_CL_11_special_exam: "",
      challaN_LIMIT_CL_12_special_exam: "",
      quotA_ARTS_REG: "",
      quotA_ARTS_PRIV: "",
      quotA_COMMERCE_REG: "",
      quotA_COMMERCE_PRIV: "",
      quotA_SCIENCE_REG: "",
      quotA_SCIENCE_PRIV: "",
      permissioN_ARTS: "",
      permissioN_COMMERCE: "",
      permissioN_SCIENCE: "",
      APPROVED_ARTS: "",
      APPROVED_COMM: "",
      APPROVED_SCI: "",
    });
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedBlock("");
    setSelectedSubDivision("");
    setTypeofschool("");
    setErrors({});
    setPreviewMode(false);
  };

  return (
    <div className="container-scroller">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-university" />
                    &nbsp;Add School
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() =>
                          navigate("/intermediate-admin-dashboard")
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Intermediate Admin Add School</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header bg-green">
                    <h4 className="mb-0 p-2">School Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Left side: School Info (col-md-9) */}
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                UDISE Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="udisE_CODE"
                                className={`form-control form-control-sm ${errors.udisE_CODE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.udisE_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.udisE_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.udisE_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Name of School{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_NAME"
                                className={`form-control form-control-sm ${errors.schooL_NAME ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.schooL_NAME || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.schooL_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Type of School</label>
                              <Select
                                value={typeofschool}
                                onChange={(selected) => {
                                  setTypeofschool(selected);
                                  setSchoolInfo((prev) => ({
                                    ...prev,
                                    typE_OF_SCHOOL: selected?.value || "",
                                  }));
                                }}
                                options={typeOfSchoolOptions}
                                isDisabled={isDisabled}
                                classNamePrefix="react-select"
                                placeholder="Select Type"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                School Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_CODE"
                                className={`form-control form-control-sm ${errors.schooL_CODE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.schooL_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={5}
                              />
                              {errors.schooL_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                School Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="sC_ADDRESS"
                                className={`form-control form-control-sm ${errors.sC_ADDRESS ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.sC_ADDRESS || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.sC_ADDRESS && (
                                <div className="text-danger mt-1 small">
                                  {errors.sC_ADDRESS}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  stateList,
                                  "statE_CODE",
                                  "statE_NAME"
                                )}
                                value={selectedState}
                                onChange={(val) =>
                                  handleSelectChange("state", val)
                                }
                                placeholder="Select State"
                                isDisabled={isDisabled}
                                className={errors.state ? "is-invalid" : ""}
                              />
                              {errors.state && (
                                <div className="text-danger mt-1 small">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                District <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredDistricts,
                                  "districT_CODE",
                                  "district"
                                )}
                                value={selectedDistrict}
                                onChange={(val) =>
                                  handleSelectChange("district", val)
                                }
                                isDisabled={!selectedState || isDisabled}
                                placeholder="Select District"
                                className={
                                  errors.districtcode ? "is-invalid" : ""
                                }
                              />
                              {errors.districtcode && (
                                <div className="text-danger mt-1 small">
                                  {errors.districtcode}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Block <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredBlocks,
                                  "blocK_ID",
                                  "blocK_NAME"
                                )}
                                value={selectedBlock}
                                onChange={(val) =>
                                  handleSelectChange("block", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Block"
                                className={
                                  errors.blocK_NAME ? "is-invalid" : ""
                                }
                              />
                              {errors.blocK_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.blocK_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Sub Division </label>
                              <Select
                                options={toOptions(
                                  filteredSubDivisions,
                                  "divisioN_ID",
                                  "divisioN_NAME"
                                )}
                                value={selectedSubDivision}
                                onChange={(val) =>
                                  handleSelectChange("subdivision", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Subdivision"
                                className={
                                  errors.suB_DIVISION ? "is-invalid" : ""
                                }
                              />
                              {errors.suB_DIVISION && (
                                <div className="text-danger mt-1 small">
                                  {errors.suB_DIVISION}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Pin Code</label>
                              <input
                                type="text"
                                name="piN_CODE"
                                className={`form-control form-control-sm ${errors.piN_CODE ? "is-invalid" : ""
                                  }`}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={schoolInfo.piN_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={6}
                              />
                              {errors.piN_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.piN_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <select
                                name="area"
                                className={`form-control form-select ${errors.area ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.area || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="RURAL">Rural</option>
                                <option value="URBAN">Urban</option>
                              </select>
                              {errors.area && (
                                <div className="text-danger mt-1 small">
                                  {errors.area}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Post Office</label>
                              <input
                                type="text"
                                name="posT_OFFICE"
                                className={`form-control form-control-sm ${errors.posT_OFFICE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.posT_OFFICE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.posT_OFFICE && (
                                <div className="text-danger mt-1 small">
                                  {errors.posT_OFFICE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Nearest Railway Station </label>
                              <input
                                type="text"
                                name="nearesT_RAILWAY_STATION"
                                className={`form-control form-control-sm ${errors.nearesT_RAILWAY_STATION
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                value={schoolInfo.nearesT_RAILWAY_STATION || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.nearesT_RAILWAY_STATION && (
                                <div className="text-danger mt-1 small">
                                  {errors.nearesT_RAILWAY_STATION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-2">
                            <div className="form-group mb-3">
                              <label>
                                Arts <br />
                                Regular Quota{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="quotA_ARTS_REG"
                                className={`form-control form-control-sm ${errors.quotA_ARTS_REG ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.quotA_ARTS_REG || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              />
                              {errors.quotA_ARTS_REG && (
                                <div className="text-danger mt-1 small">
                                  {errors.quotA_ARTS_REG}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group mb-3">
                              <label>
                                Commerce <br />
                                Regular Quota{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="quotA_COMMERCE_REG"
                                className={`form-control form-control-sm ${errors.quotA_COMMERCE_REG ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.quotA_COMMERCE_REG || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              />
                              {errors.quotA_COMMERCE_REG && (
                                <div className="text-danger mt-1 small">
                                  {errors.quotA_COMMERCE_REG}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group mb-3">
                              <label>
                                Science <br />
                                Regular Quota{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="quotA_SCIENCE_REG"
                                className={`form-control form-control-sm ${errors.quotA_SCIENCE_REG ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.quotA_SCIENCE_REG || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              />
                              {errors.quotA_SCIENCE_REG && (
                                <div className="text-danger mt-1 small">
                                  {errors.quotA_SCIENCE_REG}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group mb-3">
                              <label>
                                Arts <br />
                                Private Quota{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="quotA_ARTS_PRIV"
                                className={`form-control form-control-sm ${errors.quotA_ARTS_PRIV ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.quotA_ARTS_PRIV || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              />
                              {errors.quotA_ARTS_PRIV && (
                                <div className="text-danger mt-1 small">
                                  {errors.quotA_ARTS_PRIV}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group mb-3">
                              <label>
                                Commerce <br />
                                Private Quota{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="quotA_COMMERCE_PRIV"
                                className={`form-control form-control-sm ${errors.quotA_COMMERCE_PRIV ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.quotA_COMMERCE_PRIV || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              />
                              {errors.quotA_COMMERCE_PRIV && (
                                <div className="text-danger mt-1 small">
                                  {errors.quotA_COMMERCE_PRIV}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* <div className="col-md-2">
                                                        <div className="form-group mb-3">
                                                            <label>
                                                                Science <br />
                                                                Private Quota{" "}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="quotA_SCIENCE_PRIV"
                                                                className={`form-control form-control-sm ${errors.quotA_SCIENCE_PRIV ? "is-invalid" : ""
                                                                    }`}
                                                                value={schoolInfo.quotA_SCIENCE_PRIV || ""}
                                                                onChange={handleInputChange}
                                                                disabled={isDisabled}
                                                            />
                                                            {errors.quotA_SCIENCE_PRIV && (
                                                                <div className="text-danger mt-1 small">
                                                                    {errors.quotA_SCIENCE_PRIV}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div> */}
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                11
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class11limit;
                                    if (
                                      (parseInt(
                                        schoolInfo.challaN_LIMIT_CL_11
                                      ) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_11",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT_CL_11
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>
                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_11"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_CL_11
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfo.challaN_LIMIT_CL_11 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class11limit}
                                />
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_11",
                                        value:
                                          (parseInt(
                                            schoolInfo.challaN_LIMIT_CL_11
                                          ) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_11 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_11}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                12
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                {/* Minus Button */}
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class12limit; // define this variable like class11limit
                                    if (
                                      (parseInt(
                                        schoolInfo.challaN_LIMIT_CL_12
                                      ) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_12",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT_CL_12
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                {/* Number Input */}
                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_12"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_CL_12
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfo.challaN_LIMIT_CL_12 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class12limit}
                                />

                                {/* Plus Button */}
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_12",
                                        value:
                                          (parseInt(
                                            schoolInfo.challaN_LIMIT_CL_12
                                          ) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_12 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_12}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                11 Special Exam
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class11limitspecialexam; // define this variable like class11limit
                                    if (
                                      (parseInt(
                                        schoolInfo.challaN_LIMIT_CL_11_special_exam
                                      ) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_11_special_exam",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT_CL_11_special_exam
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>
                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_11_special_exam"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_CL_11_special_exam
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfo.challaN_LIMIT_CL_11_special_exam || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class11limitspecialexam}
                                />
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_11_special_exam",
                                        value:
                                          (parseInt(
                                            schoolInfo.challaN_LIMIT_CL_11_special_exam
                                          ) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_11_special_exam && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_11_special_exam}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                12 Special Exam
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                {/* Minus Button */}
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class12limitspecialexam; // define this variable like class11limit
                                    if (
                                      (parseInt(
                                        schoolInfo.challaN_LIMIT_CL_12_special_exam
                                      ) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_12_special_exam",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT_CL_12_special_exam
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                {/* Number Input */}
                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_12_special_exam"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_CL_12_special_exam
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfo.challaN_LIMIT_CL_12_special_exam || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class12limitspecialexam}
                                />

                                {/* Plus Button */}
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_12_special_exam",
                                        value:
                                          (parseInt(
                                            schoolInfo.challaN_LIMIT_CL_12_special_exam
                                          ) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_12_special_exam && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_12_special_exam}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side: Principal Info (col-md-3) */}
                      <div
                        className="col-md-3"
                        style={{ borderLeft: "1px solid gray" }}
                      >
                        <div className="form-group mb-3">
                          <label>Principal Name </label>
                          <input
                            type="text"
                            name="heaD_NAME"
                            className={`form-control form-control-sm ${errors.heaD_NAME ? "is-invalid" : ""
                              }`}
                            value={schoolInfo.heaD_NAME || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={50}
                          />
                          {errors.heaD_NAME && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_NAME}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="heaD_MOBILE_NO"
                            className={`form-control form-control-sm ${errors.heaD_MOBILE_NO ? "is-invalid" : ""
                              }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.heaD_MOBILE_NO || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.heaD_MOBILE_NO && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_MOBILE_NO}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Email Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            name="emaiL_ADDRESS"
                            className={`form-control form-control-sm ${errors.emaiL_ADDRESS ? "is-invalid" : ""
                              }`}
                            value={schoolInfo.emaiL_ADDRESS || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={100}
                          />
                          {errors.emaiL_ADDRESS && (
                            <div className="text-danger mt-1 small">
                              {errors.emaiL_ADDRESS}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Assistant Teacher Mobile No</label>
                          <input
                            type="text"
                            name="asstistencE_TEACHER_CONTACT"
                            className={`form-control form-control-sm ${errors.asstistencE_TEACHER_CONTACT
                              ? "is-invalid"
                              : ""
                              }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.asstistencE_TEACHER_CONTACT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.asstistencE_TEACHER_CONTACT && (
                            <div className="text-danger mt-1 small">
                              {errors.asstistencE_TEACHER_CONTACT}
                            </div>
                          )}
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            borderBottom: "1px solid #000",
                            paddingBottom: 5,
                            marginBottom: 15,
                          }}
                        >
                          <h5 style={{ display: "inline-block", margin: 0 }}>
                            Approval
                          </h5>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group mb-3">
                              <label>
                                Arts <span className="text-danger">*</span>
                              </label>
                              <select
                                name="APPROVED_ARTS"
                                className={`form-select form-control-sm ${errors.APPROVED_ARTS ? "is-invalid" : ""
                                  }`}
                                value={capitalizeFirst(
                                  schoolInfo.APPROVED_ARTS
                                )}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="Yes">YES</option>
                                <option value="No">NO</option>
                              </select>
                              {errors.APPROVED_ARTS && (
                                <div className="text-danger mt-1 small">
                                  {errors.APPROVED_ARTS}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group mb-3">
                              <label>
                                Commerce <span className="text-danger">*</span>
                              </label>
                              <select
                                name="APPROVED_COMM"
                                className={`form-select form-control-sm ${errors.APPROVED_COMM ? "is-invalid" : ""
                                  }`}
                                value={
                                  capitalizeFirst(schoolInfo.APPROVED_COMM) ||
                                  ""
                                }
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="Yes">YES</option>
                                <option value="No">NO</option>
                              </select>
                              {errors.APPROVED_COMM && (
                                <div className="text-danger mt-1 small">
                                  {errors.APPROVED_COMM}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group mb-3">
                              <label>
                                Science <span className="text-danger">*</span>
                              </label>
                              <select
                                name="APPROVED_SCI"
                                className={`form-select form-control-sm ${errors.APPROVED_SCI ? "is-invalid" : ""
                                  }`}
                                value={
                                  capitalizeFirst(schoolInfo.APPROVED_SCI) || ""
                                }
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="Yes">YES</option>
                                <option value="No">NO</option>
                              </select>
                              {errors.APPROVED_SCI && (
                                <div className="text-danger mt-1 small">
                                  {errors.APPROVED_SCI}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            textAlign: "center",
                            borderBottom: "1px solid #000",
                            paddingBottom: 5,
                            marginBottom: 15,
                          }}
                        >
                          <h5 style={{ display: "inline-block", margin: 0 }}>
                            Permission
                          </h5>
                        </div>

                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group mb-3">
                              <label>
                                Arts <span className="text-danger">*</span>
                              </label>
                              <select
                                name="permissioN_ARTS"
                                className={`form-select form-control-sm ${errors.permissioN_ARTS ? "is-invalid" : ""
                                  }`}
                                value={capitalizeFirst(
                                  schoolInfo.permissioN_ARTS
                                )}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="Yes">YES</option>
                                <option value="No">NO</option>
                              </select>
                              {errors.permissioN_ARTS && (
                                <div className="text-danger mt-1 small">
                                  {errors.permissioN_ARTS}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group mb-3">
                              <label>
                                Commerce <span className="text-danger">*</span>
                              </label>
                              <select
                                name="permissioN_COMMERCE"
                                className={`form-select form-control-sm ${errors.permissioN_COMMERCE ? "is-invalid" : ""
                                  }`}
                                value={
                                  capitalizeFirst(
                                    schoolInfo.permissioN_COMMERCE
                                  ) || ""
                                }
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="Yes">YES</option>
                                <option value="No">NO</option>
                              </select>
                              {errors.permissioN_COMMERCE && (
                                <div className="text-danger mt-1 small">
                                  {errors.permissioN_COMMERCE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group mb-3">
                              <label>
                                Science <span className="text-danger">*</span>
                              </label>
                              <select
                                name="permissioN_SCIENCE"
                                className={`form-select form-control-sm ${errors.permissioN_SCIENCE ? "is-invalid" : ""
                                  }`}
                                value={
                                  capitalizeFirst(
                                    schoolInfo.permissioN_SCIENCE
                                  ) || ""
                                }
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="Yes">YES</option>
                                <option value="No">NO</option>
                              </select>
                              {errors.permissioN_SCIENCE && (
                                <div className="text-danger mt-1 small">
                                  {errors.permissioN_SCIENCE}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action buttons */}
              <div className="col-md-12 stretch-card">
                <div className="card">
                  <div className="card-body">
                    {previewMode ? (
                      <>
                        <button
                          className="btn btn-success me-2"
                          style={{ float: "right" }}
                          onClick={handleSubmit}
                        >
                          <i className="fa fa-save" /> Save
                        </button>
                        <button
                          className="btn btn-info me-2"
                          style={{ float: "right" }}
                          onClick={handleEdit}
                        >
                          <i className="fa fa-edit" /> Edit
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-secondary me-2"
                        style={{ float: "right" }}
                        onClick={handlePreview}
                      >
                        <i className="fa fa-eye" /> Preview
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default AddSchool;
